import { all, takeLatest, call, put, select } from "redux-saga/effects";
import * as constant from "./constant";
import axios from "axios";
import {
  getAccountStatusV2Success,
  getAccountStatusV2Failed,
  getSubAccountInvestSuccess,
  getSubAccountInvestFailed,
  getInvestAnnouncementSuccess,
  getInvestAnnouncementFailed,
  getRetireAnnouncementSuccess,
  getRetireAnnouncementFailed,
  getSaveAnnouncementSuccess,
  getSaveAnnouncementFailed,
} from "./actions";
import { API_URL } from "../../../utils/axios";
import * as api from "../../../utils/api";

export const getCustAccSts = (item, token) => {
  return axios.get(`${API_URL.mp}/smp/customer/plan-status/${item}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

function* getAccountStatusV2Saga(action) {
  try {
    const accountNo = action.payload.accountNo;
    const options = action.payload.params
      ? {
          params: {
            ...action.payload.params,
          },
        }
      : undefined;
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/customer/plan-status/${accountNo}`,
      options
    );
    const { data } = res;
    if (data.sts) {
      yield put(getAccountStatusV2Success(data.sts));
      typeof action.callback === "function" && action.callback(data);
    } else {
      throw new Error("Fail to get Account Status");
    }
  } catch (error) {
    typeof action.callback === "function" && action.callback();
    yield put(getAccountStatusV2Failed(error.message));
  }
}

function* getCustomerPortfolioSaga(action) {
  try {
    const masterId = yield select(state => state.goal.profile.masterId);
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/customer-portfolio/${masterId}`
    );

    yield put({
      type: constant.GET_CUSTOMER_PORTFOLIO_SUCCESS,
      payload: res.data,
    });
    if ("callback" in action && typeof action.callback === "function") {
      action.callback(res.data);
    }
  } catch (error) {
    yield put({ type: constant.GET_CUSTOMER_PORTFOLIO_FAILED });
  }
}

function* getAccStsInvestSaga(action) {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/customer/plan-status/${action.payload}`
    );
    if (res.status === 204) {
      throw new Error("fail get sub account invest detail");
    }

    const { data } = res;
    if (typeof data === "string") {
      throw new Error("fail get sub account invest detail");
    }

    yield put(getSubAccountInvestSuccess(data));
    if ("callback" in action && typeof action.callback === "function") {
      action.callback(data);
    }
  } catch (error) {
    if ("callback" in action && typeof action.callback === "function") {
      action.callback();
    }
    yield put(getSubAccountInvestFailed());
  }
}

function* getInvestAnnouncementSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/announcement_invest`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getInvestAnnouncementSuccess(data));
  } catch (error) {
    yield put(getInvestAnnouncementFailed());
  }
}

function* getRetireAnnouncementSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/announcement_retire`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getRetireAnnouncementSuccess(data));
  } catch (error) {
    yield put(getRetireAnnouncementFailed());
  }
}

function* getSaveAnnouncementSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/announcement_save`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getSaveAnnouncementSuccess(data));
  } catch (error) {
    yield put(getSaveAnnouncementFailed());
  }
}

export function* dashboardWorkerSaga() {
  yield all([
    takeLatest(constant.GET_ACCOUNT_STATUS_V2, getAccountStatusV2Saga),
    takeLatest(constant.GET_SUBACCOUNT_INVEST, getAccStsInvestSaga),
    takeLatest(constant.GET_CUSTOMER_PORTFOLIO, getCustomerPortfolioSaga),
    takeLatest(constant.GET_INVEST_ANNOUNCEMENT, getInvestAnnouncementSaga),
    takeLatest(constant.GET_RETIRE_ANNOUNCEMENT, getRetireAnnouncementSaga),
    takeLatest(constant.GET_SAVE_ANNOUNCEMENT, getSaveAnnouncementSaga),
  ]);
}
